/* System defined core library */
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

/* User defined models */
import { DynamicFormBase } from '../models/common/dynamic-form-base.model';
import { Candidate } from '../models/scheduling/candidate.model';


@Injectable()
export class DynamicControlService {

  constructor() {
  }

  toFormGroup(inputsData: DynamicFormBase<any>[], selectedCandidate: Candidate) {
    let group: any = {};

    inputsData.forEach(input => {
      if (input.key === 'PPSN') {
        group[input.key] = new FormControl('', [this.validatePPSN]);
      } else if (input.key === 'EMAIL') {
        group[input.key] = input.required ? new FormControl(input.value || '', [Validators.required, this.checkEmails.bind(this)])
          : new FormControl(input.value || '', [this.checkEmails.bind(this)]);
      } else if (input.key === 'VALIDATE_EMAIL') {
        group[input.key] = input.required ? new FormControl(input.value || '', [Validators.required, this.checkEmails.bind(this)])
          : new FormControl(input.value || '', [this.checkEmails.bind(this)]);
      } else if (input.controlType === 'dropdown') {
        group[input.key] = input.required ? new FormControl(input.value || '', [Validators.required, this.checkListType.bind(this)])
          : new FormControl(input.value || '');
      } else if (input.controlType === 'linkedCombo') {
        // linked combobox has two dropdowns, so e need two validators to prvent errors
        group[input.key] = input.required ? new FormControl(input.value || '', [Validators.required, this.checkListType.bind(this)])
          : new FormControl(input.value || '');
        group[input.key + '_parent'] = input.required ? new FormControl(input.value || '', [Validators.required, this.checkListType.bind(this)])
          : new FormControl(input.value || '');
      } else {
        group[input.key] = input.required ? new FormControl(input.value || '', [Validators.required])
          : new FormControl(input.value || '');
        // removing required validators on non displayable flag as template does not need to validate them.
        if (!input.displayFlag) {
          group[input.key] = new FormControl(input.value || '');
        }
      }
    })

    return new FormGroup(group);
  }

  validatePPSN(input: FormControl) {
    var sum = 0;
    var ppsn = input.value;

    if (!ppsn) return null;

    if (ppsn && ppsn.length < 8) {
      return { invalidPPSN: true }
    }

    //PPSN format 9999999A with optional W at end
    //multiply first digit by 8, second by 7 and so on
    // 1110010A is valid
    for (let i = 0, j = 8; j > 1; i++, j--) {
      sum += (ppsn[i] * j);
    }

    ////Added for new published PPSN algorithm (http://www.welfare.ie/EN/Topics/PPSN/Pages/ppsnrangeextension.aspx).  Treat ' ' and 'W' as 0
    ////to maintain backwards compatibility.  All other values will be given a weighting of 9.
    if (ppsn.length > 8 && ppsn[8].toString().toUpperCase().charCodeAt(0) < 87 && ppsn[8] != ' ') {
      var lastChar = ppsn[8];
      sum += (lastChar.toString().toUpperCase().charCodeAt(0) - 64) * 9;
    }

    sum = sum % 23;

    if (sum == 0) sum = 23;

    if (sum + 64 === ppsn[7].toUpperCase().charCodeAt(0)) {
      return null;
    } else {
      return { invalidPPSN: true }
    }
  }

  // compare email and validate email if any of the value exists
  checkEmails(control: FormControl): any {
    let validateEmail = control.parent && control.parent.controls['VALIDATE_EMAIL'] && control.parent.controls['VALIDATE_EMAIL'].value;
    let email = control.parent && control.parent.controls['EMAIL'] && control.parent.controls['EMAIL'].value;
    let emailCtrl = control.parent && control.parent.controls['EMAIL'];
    let validateEmailCtrl = control.parent && control.parent.controls['VALIDATE_EMAIL'];

    if ((email && validateEmail) && email !== validateEmail)
      return { notSame: true };

    // if both values are equal and if either of them are valid, remove errors on both fields
    if (!(emailCtrl && emailCtrl.errors && emailCtrl.errors['pattern'])
      || !(validateEmailCtrl && validateEmailCtrl.errors && validateEmailCtrl.errors['pattern'])) {
      control.parent && control.parent.controls['VALIDATE_EMAIL'].setErrors(null);
      control.parent && control.parent.controls['EMAIL'].setErrors(null);
    }

    return null;
  }

  checkListType(control: FormControl): any {
    if (control.value && control.value === '-1') return { notValid: true }
    return null;
  }
}